import { render, staticRenderFns } from "./motif.vue?vue&type=template&id=56cb7983&scoped=true&"
import script from "./motif.vue?vue&type=script&lang=js&"
export * from "./motif.vue?vue&type=script&lang=js&"
import style0 from "./motif.vue?vue&type=style&index=0&id=56cb7983&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb7983",
  null
  
)

export default component.exports